import { render, staticRenderFns } from "./Login.List.Partner.vue?vue&type=template&id=1311bcc9&"
import script from "./Login.List.Partner.vue?vue&type=script&lang=js&"
export * from "./Login.List.Partner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports